export const GET_FACILIDADES = 'GET_FACILIDADES'
